import React from "react";
import { districtList } from "./helper";
import formImage from "../../assets/images/png/formImage.png";

const CMYuvaFormPart3 = ({ register, errors, liveInUp }) => {
  return (
    <div className="row g-0 h-100">
      <div className="col-12 col-lg-7 p-4 p-md-5 d-flex flex-column justify-content-center">
        <div className="mb-4">
          <h3 className="fw-bold mb-1">Residency Info</h3>
          <p className="text-gray-300 small">This scheme is exclusively available for permanent residents of Uttar Pradesh.</p>
        </div>

        {/* Question 6: UP Resident */}
        <div className="mb-4">
          <label className="form-label fw-semibold mb-2">6. Are you a permanent resident of Uttar Pradesh?</label>
          <div className="d-flex gap-4 mt-1">
            <div className="custom-radio-box">
              <input
                className="form-check-input"
                type="radio"
                value="yes"
                id="upYes"
                {...register("liveInUp", { required: "Please selection an option" })}
              />
              {/* FIXED: Removed 'stretched-link' */}
              <label className="form-check-label" style={{cursor: 'pointer'}} htmlFor="upYes">Yes</label>
            </div>
            <div className="custom-radio-box">
              <input
                className="form-check-input"
                type="radio"
                value="no"
                id="upNo"
                {...register("liveInUp")}
              />
              {/* FIXED: Removed 'stretched-link' */}
              <label className="form-check-label" style={{cursor: 'pointer'}} htmlFor="upNo">No</label>
            </div>
          </div>
          {errors.liveInUp && <div className="text-danger small mt-2">{errors.liveInUp.message}</div>}
        </div>

        {/* Question 7: District Dropdown (Only shows if Yes) */}
        {liveInUp === "yes" && (
          <div className="mb-3 animate-fade-in">
            <label className="form-label small fw-bold text-gray-300 text-uppercase">7. Select your District</label>
            <select
              className={`form-select form-select-lg backdrop-blur-md bg-white/[0.03] border border-white/10 ${errors.district ? "is-invalid" : ""}`}
              {...register("district", { required: "District is required" })}
            >
              <option value="">-- Select District --</option>
              {districtList.map((district) => (
                <option value={district} key={district}>
                  {district}
                </option>
              ))}
            </select>
            {errors.district && <div className="invalid-feedback">{errors.district.message}</div>}
          </div>
        )}
      </div>

      <div className="col-lg-5 d-none d-lg-block bg-gradient-to-b from-[#0a0a0a] via-[#0f172a] to-[#0a0a0a]">
        <img src={formImage} alt="Illustration" className="w-100 h-100 object-fit-cover" />
      </div>
    </div>
  );
};

export default CMYuvaFormPart3;
